import { render, staticRenderFns } from "./ExamsCard.vue?vue&type=template&id=94c7e868&scoped=true&"
import script from "./ExamsCard.vue?vue&type=script&lang=js&"
export * from "./ExamsCard.vue?vue&type=script&lang=js&"
import style0 from "./ExamsCard.vue?vue&type=style&index=0&id=94c7e868&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c7e868",
  null
  
)

export default component.exports